import { ref, watch, computed } from '@vue/composition-api';
import store from '@/store';
import { useToast } from 'vue-toastification/composition';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import { useUtils as useI18nUtils } from '@core/libs/i18n'

export default function useCategoryList() {
    const { t } = useI18nUtils()
    const tableColumns = [
        { key: '', label: '', sortable: false },
        { key: 'icon', label: 'Icon', sortable: false },
        { key: 'title', label: 'Title', sortable: false },
        { key: 'slug', label: 'Slug', sortable: false },
        { key: 'is_active', label: 'Status', sortable: false },
        { key: 'action', label: '#', sortable: false }
    ];
    const isCategoryFormSidebarActive = ref(false)
    const categoryData = ref(null)
    const guideCategories = ref([])
    const totalGuideCategories = ref(0)
    const searchQuery = ref('')
    const sortBy = ref('id')
    const isSortDirDesc = ref(true)
    const refCatagoryListTable = ref(null)
    const currentPage = ref(1)
    const perPage = ref(10)
    const statusFilter = ref(null)
    const toast = useToast()
    const dataMeta = computed(() => {
        const from = Math.max(1, perPage.value * (currentPage.value - 1) + 1);
        const to = Math.min(
            totalGuideCategories.value,
            perPage.value * currentPage.value
        );
        return {
            from,
            to,
            of: totalGuideCategories.value,
        }
    })

    const updateOrdering = () => {
        const filteredData = guideCategories.value?.filter(item => item !== undefined);

        store.dispatch('app-guides/updateCategoryOrdering', filteredData)
    }

    const refetchCategoryData = () => {
        fetchCategoryData();
    }

    watch([currentPage, perPage, searchQuery, statusFilter], () => {
        refetchCategoryData()
    })

    const updateCategory = (data) => {
        categoryData.value = data
        isCategoryFormSidebarActive.value = true
    }

    const resolveCatagoryStatusVariant = status => {
        if (status ) return 'success'
        if (!status ) return 'secondary'
        return 'primary'
    }

    const resolveCatagoryStatusnameVariant = status => {
        if (status) return 'Active'
        if (!status) return 'Inactive'
        return 'primary'
    }

    const fetchCategoryData = (ctx, callback) => {
        const offset = perPage.value*(currentPage.value-1);

        store
            .dispatch('app-guides/getGuideCategories', {
                limit: perPage.value,
                offset:offset,
                keywords: searchQuery.value,
                order_by: 'ordering_count DESC',
            })
            .then(response => {
                guideCategories.value = response.data.data
                totalGuideCategories.value = response.data.total
            })
            .catch(() => {
                toast({
                    component: ToastificationContent,
                    props: {
                        title: "Error fetching Category' list",
                        icon: 'AlertTriangleIcon',
                        variant: 'danger',
                    },
                })
            })
    }

    const deleteData = (id) => {
        store.dispatch('app-guides/deleteGuideCategory',id).then(response=>{
            fetchCategoryData()
            toast({
                component: ToastificationContent,
                props: {
                title: "Delete Success",
                icon: 'AlertTriangleIcon',
                variant: 'success',
                },
            })
        }).catch((error)=>{
            toast({
                component: ToastificationContent,
                props: {
                    title: "Error Delete Food Category",
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                },
            })
        })
    }

    return {
        isCategoryFormSidebarActive,
        categoryData,
        refetchCategoryData,
        fetchCategoryData,
        dataMeta,
        guideCategories,
        totalGuideCategories,
        searchQuery,
        updateCategory,
        sortBy,
        refCatagoryListTable,
        isSortDirDesc,
        resolveCatagoryStatusVariant,
        resolveCatagoryStatusnameVariant,
        tableColumns,
        deleteData,
        perPage,
        currentPage,
        updateOrdering,
    }
}